import React, { Fragment } from "react";
import ModalContainer from "../common/modal-container";

export const LoginAppShell = (props: any) => {
  return (
    <div className="font-sans">
      <ModalContainer/>
      <Fragment>
        <div className="min-h-screen bg-white flex bg-gray-100">
          {props.children}
          <div className="hidden lg:block relative w-0 flex-1">
            <img
                className="w-4/5 my-2 mx-auto"
              src="./sabuur-hills.jpeg"
              alt="data"
            />
          </div>
        </div>
      </Fragment>
    </div>
  );
};
